module.exports = __webpack_public_path__ + "assets/2887c534bd70a7422bb1a7f65e947921.mp3";